(function(){
  'use strict';
  var root=document.getElementById('dtd-sales-root');
  if(!root) return;
  document.body.classList.add('dtd-sales-active');

  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Sticky CTA: show after the hero, but hide whenever another in-page buy CTA is visible.
  var sticky=root.querySelector('#stickyCta');
  var hero=root.querySelector('#top');
  var pastHero=false;
  var visibleBuyCtas=new Set();

  function updateSticky(){
    if(!sticky) return;
    var show=pastHero&&visibleBuyCtas.size===0;
    sticky.classList.toggle('show',show);
    sticky.setAttribute('aria-hidden',show?'false':'true');
  }

  if(sticky&&hero&&'IntersectionObserver' in window){
    var heroObserver=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        pastHero=!e.isIntersecting;
        updateSticky();
      });
    },{rootMargin:'-40% 0px 0px 0px'});
    heroObserver.observe(hero);

    var buyCtas=Array.prototype.slice.call(root.querySelectorAll('a[data-dtd-buy]')).filter(function(a){
      return !a.closest('#stickyCta');
    });
    var ctaObserver=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting) visibleBuyCtas.add(e.target);
        else visibleBuyCtas.delete(e.target);
      });
      updateSticky();
    },{threshold:.25});
    buyCtas.forEach(function(a){ctaObserver.observe(a);});
  }

  var timeline=root.querySelector('#timeline');
  if(timeline){
    var steps=Array.prototype.slice.call(timeline.querySelectorAll('.tl-step'));
    var fill=timeline.querySelector('.tl-line .fill');
    function lightAll(){steps.forEach(function(s){s.classList.add('lit');});if(fill)fill.style.height='100%';}
    if(reduce||!('IntersectionObserver' in window)){lightAll();}
    else{
      var tlObserver=new IntersectionObserver(function(entries,obs){entries.forEach(function(e){if(!e.isIntersecting)return;if(fill)fill.style.height='100%';steps.forEach(function(s,i){setTimeout(function(){s.classList.add('lit');},i*130);});obs.disconnect();});},{threshold:.25});
      tlObserver.observe(timeline);
    }
  }

  if(!reduce&&'IntersectionObserver' in window){
    var targets=Array.prototype.slice.call(root.querySelectorAll('.runhead, .pain-item, .outcome, .plate, .fw, .support, .feat, .aud, .diff-col, .f60-step'));
    function show(el){el.style.opacity='1';el.style.transform='none';}
    targets.forEach(function(el){el.style.opacity='0';el.style.transform='translateY(14px)';el.style.transition='opacity .6s ease, transform .6s ease';});
    var revealer=new IntersectionObserver(function(entries,obs){entries.forEach(function(e){if(!e.isIntersecting)return;show(e.target);obs.unobserve(e.target);});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    targets.forEach(function(el){revealer.observe(el);});
    window.addEventListener('load',function(){setTimeout(function(){targets.forEach(show);},2500);});
  }

  // Sales CTA → direct GoKwik eBook checkout link.
  var gokwikCheckoutUrl = 'https://dzi81q-4f.myshopify.com?gkref=rX7oocV3Z58%2BuBV60nhMxiRIRhoI1N6qrsO%2FocR4IbuiCwMvH%2Bqmr%2FdWEup2lMKTzFYbGUnIcJUAgrog0Dz7TWmux3M2xre%2BCQytnWQ8hxVaFBr0On3jzUOBvXKF9NdcG8GfD2CMvlKzRF9ja4%2BLoSCvWtB%2Ff2lw2B%2BUdTggkw%3D%3D';
  root.addEventListener('click', function(e) {
    var a = e.target.closest('[data-dtd-buy]');
    if (!a) return;
    e.preventDefault();
    window.location.href = gokwikCheckoutUrl;
  });
})();
